// extracted by mini-css-extract-plugin
export default {"formWrapper":"user-details_formWrapper__kg6N0","fieldsWrapper":"user-details_fieldsWrapper__XvTEJ","inputField":"user-details_inputField__Pe49-","mt-2":"user-details_mt-2__cyKoP"};